// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/MajorWishListNew/index.less
// module id = 962
// module chunks = 0